<script>
import i18n from "../helpers/i18n";
//import simplebar from "simplebar-vue";
import { layoutComputed } from "@/state/helpers";
import apigeneric from "@/helpers/apigeneric";
import apibtoast from "@/helpers/apibtoast";
import resetpassword from "@/models/resetpassword";
import userupdate from "@/models/userupdate";
import { menuItems } from "./menu";

/**
 * Horizontal-topbar component
 */
export default {
  mixins: [apibtoast, apigeneric, resetpassword,userupdate],
  props: {
    type: {
      type: String,
      required: true,
    },
    width: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...layoutComputed,
  },
  components: {
    //simplebar,
  },
  data() {
    return {
      menuItems: menuItems,
      menuData: null,
      languages: [
        {
          flag: require("@/assets/images/flags/tr.jpg"),
          language: "tr",
          title: "Türkçe",
        },
        {
          flag: require("@/assets/images/flags/us.jpg"),
          language: "en",
          title: "English",
        },
        {
          flag: require("@/assets/images/flags/french.jpg"),
          language: "fr",
          title: "French",
        },
        {
          flag: require("@/assets/images/flags/spain.jpg"),
          language: "es",
          title: "spanish",
        },
        {
          flag: require("@/assets/images/flags/chaina.png"),
          language: "zh",
          title: "Chinese",
        },
        {
          flag: require("@/assets/images/flags/arabic.png"),
          language: "ar",
          title: "Arabic",
        },
      ],
      current_language: i18n.locale,
      text: null,
      flag: null,
      value: null,
      KullaniciBilgileri: "",
      FormData: {},
      userData:{},
      file: "",
      uzanti: "",
      UserImage:"",
      MenuRoleKontrol:false
    };
  },
  mounted() {   
    this.FormData = this.resetpasswordData;
    this.userData = this.userupdateData;
    this.userData.FirstName = this.UserFirsName;
    this.userData.LastName = this.UserLastName;
    this.userData.Email = this.UserEmail;
 
    this.FormData.Token = this.JWToken;
    this.FormData.Email = this.UserEmail;
    this.value = this.languages.find((x) => x.language === i18n.locale);
    this.text = this.value.title;
    this.flag = this.value.flag;
    this.MuneRolesControl(); 

  },
  methods: {
    Get(){},
    onSubmit() {
      this.$v.FormData.$touch(); 
        if (!this.$v.FormData.$invalid) { 
          this.ResetPasswordLogin(this.FormData).then((res) => { 
            if (res.Succeeded == true) {
              this.$toast.success(this.$t("ToasMessage.ResetPassPozitif"));
            } else {
              this.$toast.error(this.$t("ToasMessage.ResetPassNegatif"));
            }
          });
        }
    },
    onSubmitUser(){  
      this.$v.userData.$touch(); 
if (this.file.name) { 
        if (!this.$v.userData.$invalid) { 
          if (this.uzanti=='png' || this.uzanti=='jpeg' || this.uzanti=='jpg' ) {

                  let formData = new FormData();
                  formData.append("file", this.file);
                  this.ActionsPost({
                    Service: "GenericFileUpDownload/UploadFile?pathUrl=Avatars",
                    Data: formData,
                  }).then((res) => { 
                    if (res.Succeeded == true) { 
                      console.log(res);
                      this.userData.AvatarUrl =   res.Data.filename;
                      this.DataPostUpdate();
                    } else {
                      this.$toast.error(this.$t("ToasMessage.FileNegatif"));
                    }
                  });
                   }else{
          this.$toast.error(this.$t("ToasMessage.FileNegatifUzanti"));
        }
        }
        } else {
          this.DataPostUpdate();
        }
    },
    DataPostUpdate() { 
        
        var FormData = this.userData
        if(!this.file.name){
            this.$delete(FormData, "AvatarUrl"); 
        }
         
        
        console.log(FormData);
        this.UserUpdateLogin(FormData).then((res) => { 
            if (res.Succeeded == true) {
              this.$toast.success(this.$t("ToasMessage.UpdatePozitif"));
            } else {
              this.$toast.error(this.$t("ToasMessage.UpdateNegatif"));
            }
          });
       
    },
    
    FileUpload() {
      this.file = this.$refs.file.files[0];
      let x = this.file.name;
      //this.FormData.Filename = this.file.name;
      this.uzanti = x.substr(
        x.lastIndexOf(".") + 1,
        x.length - x.lastIndexOf(".")
      ); 
       if ( this.uzanti=='png' || this.uzanti=='jpeg' || this.uzanti=='jpg' ) {
      
      this.uzanti = this.uzanti
      }else{
 this.$toast.error(this.$t("ToasMessage.FileNegatifUzanti"));
      }
    },
    MuneRolesControl() {  
      let YetkiSorgu = this.UserRolles.filter((item) =>
        item.includes("SuperAdmin")
      );
      if (YetkiSorgu.length != 0) this.MenuRoleKontrol = true; 
    },
    toggleRightSidebar() {
      this.$parent.toggleRightSidebar();
    },
    toggleMenu() {
      let element = document.getElementById("topnav-menu-content");
      element.classList.toggle("show");
    },
    initFullScreen() {
      document.body.classList.toggle("fullscreen-enable");
      if (
        !document.fullscreenElement &&
        /* alternative standard method */ !document.mozFullScreenElement &&
        !document.webkitFullscreenElement
      ) {
        // current working methods
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(
            Element.ALLOW_KEYBOARD_INPUT
          );
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },
    setLanguage(locale, country, flag) {
      this.current_language = locale;
      this.text = country;
      this.flag = flag;
      i18n.locale = locale;
    },
  },
  watch: {
    type: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          switch (newVal) {
            case "dark":
              document.body.setAttribute("data-topbar", "dark");
              document.body.removeAttribute("data-layout-scrollable");
              break;
            case "light":
              document.body.setAttribute("data-topbar", "light");
              document.body.removeAttribute("data-layout-size", "boxed");
              document.body.removeAttribute("data-layout-scrollable");
              break;
            case "colored":
              document.body.setAttribute("data-topbar", "colored");
              document.body.removeAttribute("data-layout-size", "boxed");
              break;
            default:
              document.body.setAttribute("data-topbar", "dark");
              break;
          }
        }
      },
    },
    width: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          switch (newVal) {
            case "boxed":
              document.body.setAttribute("data-layout-size", "boxed");
              document.body.removeAttribute("data-layout-scrollable");
              break;
            case "fluid":
              document.body.setAttribute("data-layout-mode", "fluid");
              document.body.removeAttribute("data-layout-scrollable");
              document.body.removeAttribute("data-layout-size");
              break;
            case "scrollable":
              document.body.setAttribute("data-layout-scrollable", "true");
              document.body.removeAttribute("data-layout-mode");
              document.body.removeAttribute("data-layout-size");
              break;
            default:
              document.body.setAttribute("data-layout-mode", "fluid");
              break;
          }
        }
      },
    },
  },
};
</script>

<template> 
  <header id="page-topbar"> 
    <div class="navbar-header">
      <div class="d-flex">
        <!-- LOGO -->
        <div class="navbar-brand-box logo-bg">
          <router-link to="/" class="logo logo-dark">
            <span class="logo-sm">
              <img
                src="/assets/images/Kurum_Logo.png"
                alt 
                height="59"
              />
            </span>
            <span class="logo-lg">
              <img
                src="/assets/images/Kurum_Logo.png"
                class="mt-auto"
                alt
                height="59"
              />
            </span>
          </router-link>

          <router-link to="/" class="logo logo-light">
            <span class="logo-sm">
              <img
                src="/assets/images/Kurum_Logo.png"
                alt
                height="59"
              />
            </span>
            <span class="logo-lg">
              <img
                src="/assets/images/Kurum_Logo.png"
                class="mt-auto"
                alt
                height="59"
              />
            </span>
          </router-link>
        </div>
        <div class="price mx-4" style="">
          <div class="d-inline-block text-white">
            <h4 class="m-0 p-0 text-white">
              {{ $t("horizontal_topbar.page.uygulamadi") }}
            </h4>
            <p class="m-0 p-0">
              {{ $t("horizontal_topbar.page.uygulamadi2") }}
            </p>
          </div>
        </div>
      </div>

      <div class="d-flex">
        <!-- App Search--> 

        <form class="app-search d-none d-lg-block mx-4">
          <div class="position-relative">
            <input
              @input="$emit('uygulamaarama', $event.target.value)"
              type="text"
              class="form-control"
              :placeholder="$t('horizontal_topbar.page.arama')"
            />
            <span class="bx bx-search-alt"></span>
          </div>
        </form>

        <b-dropdown right variant="black" toggle-class="header-item">
          <template v-slot:button-content> 
            <img
              class="rounded-circle header-profile-user"
              :src="AvatarUrl ? $config.AVATAR_URL+AvatarUrl : 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAeCAMAAACR41cYAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAJ/UExURUdwTCEgIB8fHyAfHyAfHyAfHyAfHx8eHiAfHx8eHiAfHyAfHyAfHx8eHiAfH5jU5h8eHiAfHyAfHyAfHx8eHh8eHiAfHyAfIAQBAxgWFiEhISEgIAwCACAgIB0bGi40NhkVFCAfH5za8FBncENVXKTm95vZ8Jza8J7c8R0bGhMTEx0cHCAfHyEgH73//yEgIJ7c8QAAAIfF6TM7PwwJCh4cHHm45SAfHyAfH5za8CAfH5za8Jza8Jza8Jza8CAfH5za8G6VokRVWxIKCJza8JvY7pza8DtITTlFSZ3b8AMHCgAABJza8ElBPDA4PFVLRK3z/zEvLRcXGEVBPTA5PJza8AADB5vZ74XD6QIAAIrJ67T+/4HA6BAIByAfH4zK7IrI6zE4O7D5/yAfHwEAACIgIJza8BUWGAACBhoaGvXLsQ0PEZ/g957c8RATFf/oy1p4hfzRticqLIC+6Jrm///jxiMiIvDEq//Xu/bHq//fxG5eVRgXF////P/z0P/22lNHQv/gv//877H5/xcTEhUOC76cicyolCcjIf/avdivlpvY7mZaUQMHC1lNRfrNsPTJr//o0v/cwf3WuHtnXIshF4VuYvTEqfrcyM+oqOrW1PTm4v716zM7PqHf8v/t1SkpJsD//1RueGebxaPn/IXK/TVIV3OapbmXheK0mNuymv/GrdWZhu/Tx+u7pI54adymkf/658+dlMifn+S1mafq+7uhizYvLeLCufLs7/rk1mNVTf/NrtOskqeHd8aXlXFgVv/kwZU1LNW1neK9tJAuJsCMirJwa+nKv9zFx2CRtVuKronG6naszSUnKUZaZG+TmUFPU3agr3GkxIu8xSfH+3sAAABzdFJOUwD97RwqJTMat/4VL6DlCwmSOh2qV77yhGEIms8njIj9+xEk6wESA6CMcwRtUGQlwnjIs9iu9u3fsS5e3hvwhB66hguP9eJfotdT9nPf4o7mPNW62Kc/5MnTMeRzzcTG3/LkYv////////////////////54WQMpAAACTklEQVQYGXXABVMiYRgA4BdYdhkExa5TR8Xuvu7u7v5g2V06XFGxO7C72+vu7s74Qaczd87sIg/85yeUJMMCsUK+FFzIEEISvwSZxF8iSwpEczyBT4L4xMAXhniE4CIQ8QRgwCMWID458PgipEYag0ZD07TGYHCgOcuBI1GIWA3lqEcOrVbrUNdXUzSLfIHDB7EG7fXGi411tRdq6y7dedrl1KjTgGMNop3PSm+WGO35+fkNHSUlpT0U8geO4ABneUX7w9tXWxmGKXzU/7HyyX2tBLhCVT0vh/q7b7W3MW1Fb169H6p4TIXAP1IRQfiIMV/qRUXl8+4HHUwnY//w9l1lZ7kzHBP7EIRICpg3juMemLd2zGwcHOjrLbjB9PYNDI72sgYc88Bx3BsDQiSN9FQCpFDFxrKyVvO1KwXmwtGy0i4qBUDpGSkVEbDA73D5vYIGo/2y3Vhkfl28PQl4NoQABAdl79vV0lzc3LLnwP4dBPB4rbNkwbwM1byMRHAVk7qe3gIAyWpWIBCwKAgWFTS8dfdBQY5cIMsRsv6wuARLhIU+rUBhKCQgFNwIPrYkTR6uVqjD80LBvWxhIFKgsLxT4IYy9XyWJbo6ujo64tyJvbGwiM1H9OM/kalmosb0bXhct2m1F/DExpG6KZPqxy/Vd9XsrGriro5cEQVcUSSp05s+T0XU/HGM6T6Z9DqSjAcur7Vkk77KNjnzu+rrzKStSt9ErloGfOk7yRGr1Tb9ZdpmtY6QG+NWgivlofTMk2dyz+YeP5oZvy0GFvwFlSbPVswTomsAAAAASUVORK5CYII='"
              :alt="UserNameSurName"
            />
            <span class="d-none d-xl-inline-block ms-1">
              {{
                UserNameSurName
              }}
            </span>
            <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
          </template>
          <!-- item-->
          <div class="w-100 profil-info p-3">
            <h5>
              {{
                UserNameSurName
              }}
            </h5>
          </div>
          <b-dropdown-item v-if="MenuRoleKontrol">
            <router-link tag="span" to="/userroles">
              <i class="mdi mdi-eye-off font-size-16 align-middle me-1"></i>
              {{ $t("navbar.user.kullanicirolleri") }}
            </router-link>
          </b-dropdown-item>
          
          <b-dropdown-item v-if="MenuRoleKontrol">
            <router-link tag="span" to="/ouserbirimyetki">
              <i class="mdi mdi-file-eye-outline font-size-16 align-middle me-1"></i>
              {{ $t("navbar.user.birimrolleri") }}
            </router-link>
          </b-dropdown-item>
          <b-dropdown-item v-if="MenuRoleKontrol">
            <router-link tag="span" to="/userswebsiteyetki">
              <i class="bx bx-buildings font-size-16 align-middle me-1"></i>
              {{ $t("navbar.user.userswebsiteyetki") }}
            </router-link>
          </b-dropdown-item>
          <b-dropdown-item v-b-modal.userupdate>
            <i
              class="
                bx bx-user 
                font-size-16
                align-middle
                me-1
              "
            ></i>
            {{ $t("navbar.user.profilguncelle") }}
          </b-dropdown-item>
          <b-dropdown-item v-b-modal.reset-password>
            <i
              class="
                mdi mdi-form-textbox-password
                font-size-16
                align-middle
                me-1
              "
            ></i>
            {{ $t("navbar.user.sifredegistir") }}
          </b-dropdown-item>
          <b-dropdown-divider></b-dropdown-divider>
          <a href="/logout" class="dropdown-item text-danger">
            <i
              class="bx bx-power-off font-size-16 align-middle me-1 text-danger"
            ></i>
            {{ $t("navbar.user.cikis") }}
          </a>
        </b-dropdown>
        <!--
        <div class="price mx-4 d-none d-sm-block">
         <div class="d-inline-block text-white">
          <p class="m-0 p-0 text-white">SKS <span class="text-white d-inline-block ">0.00 ₺</span></p>
          <p class="m-0 p-0 text-white">İİM <span class="text-white d-inline-block float-end">0.00 ₺</span></p>
         </div>
        </div>
-->
        <!--
        <b-dropdown
          menu-class="dropdown-menu-lg p-0 dropdown-menu-end"
          toggle-class="header-item noti-icon"
          variant="black"
        >
          <template v-slot:button-content>
            <i class="bx bx-bell bx-tada"></i>
            <span class="badge bg-danger rounded-pill">{{
              $t("navbar.dropdown.notification.badge")
            }}</span>
          </template>

          <div class="p-3">
            <div class="row align-items-center">
              <div class="col">
                <h6 class="m-0">
                  {{ $t("navbar.dropdown.notification.text") }}
                </h6>
              </div>
              <div class="col-auto">
                <a href="#" class="small">{{
                  $t("navbar.dropdown.notification.subtext")
                }}</a>
              </div>
            </div>
          </div>
          <simplebar style="max-height: 230px">
            <a href="javascript: void(0);" class="text-reset notification-item">
              <div class="media">
                <div class="avatar-xs me-3">
                  <span
                    class="avatar-title bg-primary rounded-circle font-size-16"
                  >
                    <i class="bx bx-cart"></i>
                  </span>
                </div>
                <div class="media-body">
                  <h6 class="mt-0 mb-1">
                    {{ $t("navbar.dropdown.notification.order.title") }}
                  </h6>
                  <div class="font-size-12 text-muted">
                    <p class="mb-1">
                      {{ $t("navbar.dropdown.notification.order.text") }}
                    </p>
                    <p class="mb-0">
                      <i class="mdi mdi-clock-outline"></i>
                      {{ $t("navbar.dropdown.notification.order.time") }}
                    </p>
                  </div>
                </div>
              </div>
            </a>
            <a href="javascript: void(0);" class="text-reset notification-item">
              <div class="media">
                <img
                  src="@/assets/images/brands/github.png"
                  class="me-3 rounded-circle avatar-xs"
                  alt="user-pic"
                />
                <div class="media-body">
                  <h6 class="mt-0 mb-1">
                    {{ $t("navbar.dropdown.notification.james.title") }}
                  </h6>
                  <div class="font-size-12 text-muted">
                    <p class="mb-1">
                      {{ $t("navbar.dropdown.notification.james.text") }}
                    </p>
                    <p class="mb-0">
                      <i class="mdi mdi-clock-outline"></i>
                      {{ $t("navbar.dropdown.notification.james.time") }}
                    </p>
                  </div>
                </div>
              </div>
            </a>
            <a href="javascript: void(0);" class="text-reset notification-item">
              <div class="media">
                <div class="avatar-xs me-3">
                  <span
                    class="avatar-title bg-success rounded-circle font-size-16"
                  >
                    <i class="bx bx-badge-check"></i>
                  </span>
                </div>
                <div class="media-body">
                  <h6 class="mt-0 mb-1">
                    {{ $t("navbar.dropdown.notification.item.title") }}
                  </h6>
                  <div class="font-size-12 text-muted">
                    <p class="mb-1">
                      {{ $t("navbar.dropdown.notification.item.text") }}
                    </p>
                    <p class="mb-0">
                      <i class="mdi mdi-clock-outline"></i>
                      {{ $t("navbar.dropdown.notification.item.time") }}
                    </p>
                  </div>
                </div>
              </div>
            </a>
            <a href="javascript: void(0);" class="text-reset notification-item">
              <div class="media">
                <img
                  src="@/assets/images/brands/github.png"
                  class="me-3 rounded-circle avatar-xs"
                  alt="user-pic"
                />
                <div class="media-body">
                  <h6 class="mt-0 mb-1">
                    {{ $t("navbar.dropdown.notification.salena.title") }}
                  </h6>
                  <div class="font-size-12 text-muted">
                    <p class="mb-1">
                      {{ $t("navbar.dropdown.notification.salena.text") }}
                    </p>
                    <p class="mb-0">
                      <i class="mdi mdi-clock-outline"></i>
                      {{ $t("navbar.dropdown.notification.salena.time") }}
                    </p>
                  </div>
                </div>
              </div>
            </a>
          </simplebar>
          <div class="p-2 border-top d-grid">
            <a
              class="btn btn-sm btn-link font-size-14 text-center"
              href="javascript:void(0)"
            >
              <i class="mdi mdi-arrow-right-circle me-1"></i>
              <span key="t-view-more">
                {{ $t("navbar.dropdown.notification.button") }}</span
              >
            </a>
          </div>
        </b-dropdown>
-->
      </div>
    </div>

    <b-modal
      id="reset-password"
      size="lg"
      centered
      :title="$t('resetpassword.Title')"
      title-class="font-18"
      hide-footer
    >
      <Form @submit.prevent="onSubmit">
        <b-form-group
          :label="FormDataType.Password.FieldTitle"
          class="mb-3"
          id="input-group-2"
          label-for="input-2"
        >
          <b-form-input
            id="input-2"
            class="form-control"
            v-model="FormData.Password"
            type="password"
            :class="{
              'is-invalid': $v.FormData.Password.$error,
            }"
          ></b-form-input>
          <div v-if="!$v.FormData.Password.required" class="invalid-feedback">
            {{ $t("ValidationMessage.required") }}
          </div>
          <div
            v-if="!$v.FormData.Password.minLength"
            class="invalid-feedback"
          >
            {{ $t("ValidationMessage.minLength") }}
          </div>
        </b-form-group>
        <b-form-group
          :label="FormDataType.ConfirmPassword.FieldTitle"
          class="mb-3"
          id="input-group-2"
          label-for="input-2"
        >
          <b-form-input
            id="input-2"
            class="form-control"
            v-model="FormData.ConfirmPassword"
            type="password"
            :class="{
              'is-invalid': $v.FormData.ConfirmPassword.$error,
            }"
          ></b-form-input> 
          <div
            v-if="!$v.FormData.ConfirmPassword.sameAs"
            class="invalid-feedback"
          >
            {{ $t("ValidationMessage.sameAs") }}
          </div> 
        </b-form-group>
        <button class="btn btn-primary" type="submit">
          {{ $t("resetpassword.AddEdit.Button") }}
        </button>
      </Form>
    </b-modal>


     <b-modal
      id="userupdate"
      size="lg"
      centered
      :title="$t('userupdate.Title')"
      title-class="font-18"
      hide-footer
    >
      <Form @submit.prevent="onSubmitUser"> 
  <b-form-group
          :label="FormDataType.FirstName.FieldTitle"
          class="mb-3"
          id="input-group-2"
          label-for="input-2"
        >
          <b-form-input
            id="input-2"
            class="form-control"
            v-model="userData.FirstName"
            type="text"
            :class="{
              'is-invalid': $v.userData.FirstName.$error,
            }"
          ></b-form-input>
          <div v-if="!$v.userData.FirstName.required" class="invalid-feedback">
            {{ $t("ValidationMessage.required") }}
          </div> 
        </b-form-group>
 
  <b-form-group
          :label="FormDataType.LastName.FieldTitle"
          class="mb-3"
          id="input-group-2"
          label-for="input-2"
        >
          <b-form-input
            id="input-2"
            class="form-control"
            v-model="userData.LastName"
            type="text"
            :class="{
              'is-invalid': $v.userData.LastName.$error,
            }"
          ></b-form-input>
          <div v-if="!$v.userData.LastName.required" class="invalid-feedback">
            {{ $t("ValidationMessage.required") }}
          </div> 
        </b-form-group>
 

         <b-form-group
              id="example text"
              :label="FormDataType.AvatarUrl.FieldTitle"
              label-for="text"
            >
              <input
                class="form-control"
                ref="file"
                type="file"
                v-on:change="FileUpload($event)"
                id="FormData.AvatarUrl"
                accept=".jpg, .jpeg, .png "
              />
            </b-form-group>

        <button class="btn btn-primary mt-3" type="submit">
          {{ $t("resetpassword.AddEdit.Button") }}
        </button>
       </Form>
    </b-modal> 
  </header>
</template>


<style>
.profil-info {
  background-color: #2a3042;
  margin-top: -3px;
}
.profil-info p {
  color: white;
  padding: 0px;
  margin: 0px;
  font-size: 9px;
}
.profil-info h5 {
  padding: 0px;
  margin: 0px;
  color: white;
  font-size: 12px;
}
.price {
  padding: calc(32px / 2) 0;
  font-weight: 500;
}
.price p span {
  font-weight: 300;
}
#page-topbar::before {
  content: " ";
  width: 100%;
  height: 3px;
  background-color: #2a3042;
  position: absolute;
  bottom: -8px;
  left: 0px;
}

.logo-bg {
  background-color: white;
}
</style>